import { redirect } from '@tanstack/react-router'
import { RouterContext } from '@/routes/__root'
import validateAppDest from '@/common/lib/validateAppDest'

/**
 * Check if user is staff or admin.
 * Throws redirect if not.
 *
 * Assumes auth bootstrap is already complete (enforced by BootstrapGate
 * in index.tsx which gates RouterProvider until bootstrapped).
 */
export function requireStaff(context: RouterContext) {
  const currentUser = context.currentUser

  if (!currentUser?.isAuthenticated) {
    const from = `${window.location.pathname}${window.location.search}`
    const search = validateAppDest(from) ? { from } : undefined
    throw redirect({ to: '/app/account/login', search })
  }

  const userSystemRole = currentUser.data?.system_role_machine_name ?? null

  if (userSystemRole !== 'staff' && userSystemRole !== 'admin') {
    throw redirect({
      to: '/app/account/login',
    })
  }
}
